/**
 * Configuração de Manutenção do Sistema
 *
 * Para ativar a tela de manutenção, altere MAINTENANCE_MODE para true
 * Quando ativado, todos os usuários serão redirecionados para a tela de manutenção
 * e não poderão navegar para nenhuma outra página.
 */

export const MAINTENANCE_MODE = false

// Mensagem opcional para exibir na tela de manutenção
export const MAINTENANCE_MESSAGE =
  'Estamos realizando melhorias no sistema para oferecer uma experiência ainda melhor.'
